import React from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import { productsData } from '@/mocks/products';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

const Products = ({ data, showViewAll = true }: any) => {
  const products = data || productsData;
  const displayedProducts = showViewAll ? products.slice(0, 8) : products;

  return (
    <div className="container py-8 md:py-16">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center text-center gap-4 mb-8 md:mb-12"
      >
        <p className="uppercase text-[24px] md:text-[32px] font-bold text-gray2">
          Sản phẩm của chúng tôi
        </p>
        <p className="text-[16px] md:text-[18px] font-medium text-gray-600 max-w-3xl">
          Cung cấp đa dạng các loại trứng gà tươi ngon, chất lượng cao, đảm bảo
          vệ sinh an toàn thực phẩm
        </p>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
      >
        {displayedProducts.map((product: any) => (
          <motion.div
            key={product.id}
            variants={itemVariants}
            whileHover={{ y: -8 }}
            transition={{ duration: 0.3 }}
            className="group cursor-pointer"
          >
            <Link href={`/products/${product.slug}`}>
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
                <div className="relative w-full aspect-square overflow-hidden">
                  <Image
                    src={product.thumbnail}
                    alt={product.name}
                    fill
                    className="object-cover transition-transform duration-500 group-hover:scale-110"
                    sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                  <h3 className="text-[16px] md:text-[18px] font-semibold text-gray2 line-clamp-2 group-hover:text-primary transition-colors duration-300">
                    {product.name}
                  </h3>
                  <p className="text-[14px] text-gray-600 line-clamp-2 flex-1">
                    {product.description}
                  </p>
                  <div className="pt-2">
                    <span className="text-primary text-[14px] md:text-[16px] font-semibold">
                      LIÊN HỆ
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </motion.div>

      {showViewAll && products.length > 8 && (
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex justify-center mt-8 md:mt-12"
        >
          <Link
            href="/products"
            className="bg-primary text-white duration-300 w-fit text-[16px] md:text-[18px] py-2 px-8 rounded-full hover:bg-transparent relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary hover:text-primary"
          >
            Xem tất cả sản phẩm
          </Link>
        </motion.div>
      )}
    </div>
  );
};

export default Products;
